import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL

const getPlanosTrabalhoPorEdital = async (token: string, idEdital: number, page: number = 1) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    }
  };
  const response = await axios.get(`${API_URL}/planos-de-trabalho/edital/${idEdital}?page=${page}`, config);
  return response.data;
};

export default getPlanosTrabalhoPorEdital;